module.exports = __webpack_public_path__ + "0.1.2/img/mean-link.e4f3afcc.jpeg";